<template>
  <v-form v-model="valid" :readonly="pending" @submit.prevent="() => onSubmit()">
    <v-card-text>
      <v-text-field
        v-model="fileDescription"
        :label="$t('description')"
        autofocus
        :rules="[(val) => !!val || $t('required')]"
        :suffix="`.${fileData.extension}`"
      />
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn color="secondary" class="custom-hover-secondary" @click="onCancel">{{ $t("cancel") }}</v-btn>
      <v-btn variant="flat" color="primary" class="custom-hover-primary" type="submit" :disabled="!valid" :loading="pending">{{
        $t("save")
      }}</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script setup lang="ts">
const $i18n = useI18n()

const fileStore = useFileStore()
const mainStore = useMainStore()

const emit = defineEmits<{
  (event: "ok", value: string): void
  (event: "cancel"): void
}>()

const props = defineProps<{ fileData: FileData }>()
const { fileData } = toRefs(props)

const fileDescription = ref(fileData.value.description)
const pending = ref(false)
const valid = ref<boolean | null>(null)

const onSubmit = () => {
  useExplicitSave(mainStore.notify, $i18n, async () => {
    if (!valid.value) {
      return
    }

    pending.value = true

    try {
      const newFileData = await fileStore.patchFile(fileData.value._id, { description: fileDescription.value ?? "" })
      emit("ok", newFileData.description)
    } catch (e) {
      const errorMessage = getErrorMessage(e)
      console.error(errorMessage)
      throw e
    } finally {
      pending.value = false
    }
  })
}
const onCancel = () => {
  emit("cancel")
}
</script>
